import {
  NFTS_SORT_KEYS,
  NFTS_SORT_TYPES,
  sortKeys,
} from '../../pages/NFTs/nftsConstants';
import { sortItemsByConfig } from '../../helpers/tableSort';
import * as types from './nftActionTypes';

const initialState = {
  nfts: null,
  filteredNfts: null,
  nft: null,
  createdNft: null,
  updatedNft: null,
  deletedNft: null,
  nftsSortData: {
    sortType: NFTS_SORT_TYPES.ASCENDING,
    sortKey: NFTS_SORT_KEYS.NFT_NAME,
  },
  quickFilter: 1,
  error: {
    type: null,
    data: null,
  },
};

export const nftReducer = (state = initialState, action) => {
  const sortNftsByCurrentSort = (
    nfts = [],
    sortData = state.nftsSortData
  ) => sortItemsByConfig(
    nfts,
    sortData,
    sortKeys,
    NFTS_SORT_TYPES.ASCENDING
  );

  switch (action.type) {
    case types.GET_NFTS_DATA:
      return {
        ...state,
        nfts: action.payload?.result ? sortNftsByCurrentSort(action.payload.result) : null,
        filteredNfts: null,
      };

    case types.GET_NFTS_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_NFTS_ERROR,
          data: action.payload,
        },
      };

    case types.CREATE_NFT_REQUEST:
      return {
        ...state,
        createdNft: null,
        error: {
          type: null,
          data: null,
        },
      };

    case types.CREATE_NFT_DATA:
      return {
        ...state,
        createdNft: action.payload,
      };

    case types.CREATE_NFT_ERROR:
      return {
        ...state,
        createdNft: null,
        error: {
          type: types.CREATE_NFT_ERROR,
          data: action.payload,
        },
      };

    case types.UPDATE_NFT_REQUEST:
      return {
        ...state,
        updatedNft: null,
        error: {
          type: null,
          data: null,
        },
      };

    case types.UPDATE_NFT_DATA:
      return {
        ...state,
        updatedNft: action.payload,
      };

    case types.UPDATE_NFT_ERROR:
      return {
        ...state,
        updatedNft: null,
        error: {
          type: types.UPDATE_NFT_ERROR,
          data: action.payload,
        },
      };

    case types.DELETE_NFT_DATA: {
      const deletedNftID = action.payload;
      const updatedNfts = state.nfts ? state.nfts.filter((n) => n.id !== deletedNftID) : state.nfts;
      const updatedFilteredNfts = state.filteredNfts
        ? state.filteredNfts.filter((n) => n.id !== deletedNftID)
        : state.filteredNfts;

      return {
        ...state,
        nfts: updatedNfts ? [...updatedNfts] : null,
        filteredNfts: updatedFilteredNfts ? [...updatedFilteredNfts] : null,
        deletedNft: deletedNftID,
      };
    }

    case types.DELETE_NFT_ERROR:
      return {
        ...state,
        error: {
          type: types.DELETE_NFT_ERROR,
          data: action.payload,
        },
      };

    case types.FILTER_NFTS: {
      const filterInput = action?.payload?.toString().toLowerCase() || '';
      const filteredNfts = [];
      const tempNftsForFilter = state.nfts;

      if (!tempNftsForFilter) {
        return {
          ...state,
          filteredNfts: null,
        };
      }

      for (const nft of tempNftsForFilter) {
        const contractAddress = nft?.nft_contract?.contract_address || '';
        const contractOwnerAddress = nft?.nft_contract?.contract_owner_address || '';

        if (
          nft?.name?.toString().toLowerCase().includes(filterInput) ||
          nft?.url?.toString().toLowerCase().includes(filterInput) ||
          nft?.address?.toString().toLowerCase().includes(filterInput) ||
          nft?.owner_address?.toString().toLowerCase().includes(filterInput) ||
          contractAddress.toString().toLowerCase().includes(filterInput) ||
          contractOwnerAddress.toString().toLowerCase().includes(filterInput)
        ) {
          filteredNfts.push(nft);
        }
      }

      return {
        ...state,
        filteredNfts: [...filteredNfts],
      };
    }

    case types.SET_NFTS_SORT_DATA:
      return {
        ...state,
        nftsSortData: { ...action.payload },
      };

    case types.SORT_NFTS: {
      const tempNftsForSorting = state.filteredNfts?.length ? state.filteredNfts : state.nfts;
      const sortedNfts = sortNftsByCurrentSort(tempNftsForSorting);

      if (state.filteredNfts?.length) {
        return {
          ...state,
          filteredNfts: sortedNfts ? [...sortedNfts] : null,
        };
      }

      return {
        ...state,
        nfts: sortedNfts ? [...sortedNfts] : state.nfts,
      };
    }

    case types.UPDATE_QUICK_FILTER:
      return {
        ...state,
        quickFilter: action?.payload,
      };

    default:
      return state;
  }
};
